var _style, _g, _rect, _g2, _g3, _circle, _circle2, _g4, _path, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#384D5B;}\n\t.st1{fill:#00C0FF;}\n\t.st2{opacity:0.55;}\n\t.st3{fill:none;stroke:#384D5B;stroke-width:3;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#395077;}\n\t.st7{fill:#D9D9D9;}\n\t.st8{fill:url(#Rectangle_2546_00000139265748170164330170000010063276058958867881_);}\n\t.st9{fill:url(#Path_11275_00000026131310084905513460000015987046405708526002_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2545_00000135649659650303350390000010521442961549427884_",
    x: -645.16,
    y: 307.29,
    className: "st0",
    width: 102.07,
    height: 62.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2546_00000000906411044679802050000016697651792201617064_",
    className: "st1",
    d: "M-653.79,258.34h119.33 c6.35,0,11.5,5.15,11.5,11.5v52.2c0,6.35-5.15,11.5-11.5,11.5h-119.33c-6.35,0-11.5-5.15-11.5-11.5v-52.2 C-665.3,263.49-660.14,258.34-653.79,258.34z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11161_00000002366911011089698290000002552675058413126020_",
    transform: "translate(73.586)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1_00000106120311239034824920000003501294213978911636_",
    className: "st3",
    x1: -720.47,
    y1: 258.34,
    x2: -720.47,
    y2: 333.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2_00000067917839353488545190000012852370999187230859_",
    className: "st3",
    x1: -699.37,
    y1: 258.34,
    x2: -699.37,
    y2: 333.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3_00000065047873070693868350000011444865140579064966_",
    className: "st3",
    x1: -678.26,
    y1: 258.34,
    x2: -678.26,
    y2: 333.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4_00000183943264808465758640000011581544471177948066_",
    className: "st3",
    x1: -657.15,
    y1: 258.34,
    x2: -657.15,
    y2: 333.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5_00000151503897645836880660000007920418769976868513_",
    className: "st3",
    x1: -636.05,
    y1: 258.34,
    x2: -636.05,
    y2: 333.56
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6_00000070110946680718031840000007334851373320513925_",
    className: "st3",
    x1: -614.94,
    y1: 258.34,
    x2: -614.94,
    y2: 333.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11163_00000070833397486273079700000002879413988301884086_",
    transform: "translate(21.278 36.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11162_00000109020051889766260870000007906152242121324437_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547_00000028283373761095069180000013549266479001714845_",
    className: "st0",
    d: "M-508.34,359.69l30.23-30.23 c1.72-1.72,4.5-1.72,6.22,0l54.98,54.98c1.72,1.72,1.72,4.5,0,6.22l-30.23,30.23c-1.72,1.72-4.5,1.72-6.22,0l-54.98-54.98 C-510.06,364.19-510.06,361.41-508.34,359.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2548_00000020399173185878050690000008311609748385218715_",
    className: "st0",
    d: "M-813.9,384.44l54.98-54.98 c1.72-1.72,4.5-1.72,6.22,0l30.23,30.23c1.72,1.72,1.72,4.5,0,6.22l-54.98,54.98c-1.72,1.72-4.5,1.72-6.22,0l-30.23-30.23 C-815.62,388.94-815.62,386.16-813.9,384.44z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11183_00000065054664098559341360000011539731136174222495_",
    transform: "translate(0 20.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11275_00000070084939586007003670000005875107250307826874_",
    className: "st1",
    d: "M-631.97,334.6 c123.89-20.9,241.26,62.59,262.16,186.47c20.9,123.89-62.59,241.26-186.47,262.16c-123.89,20.9-241.26-62.59-262.16-186.47 C-839.34,472.87-755.85,355.5-631.97,334.6C-631.97,334.6-631.97,334.6-631.97,334.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3342_00000016069013178120815000000010363777178326589856_",
    className: "st4",
    cx: -594.12,
    cy: 558.91,
    r: 199.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3343_00000176025183338415238220000010125627341260558473_",
    className: "st5",
    cx: -594.12,
    cy: 558.91,
    r: 190.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11180_00000170999501150478397780000016991547663282472344_",
    transform: "translate(29.375 29.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11179_00000150062794259944503140000017951626783292311703_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11166_00000094602651272190346200000012987808195442548354_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11164_00000161633722187633482570000001192670439320783249_",
    transform: "translate(60.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11260_00000060032596368581354430000012034417998158091435_",
    className: "st6",
    d: "M-675.91,358.62 c0,4.23-3.43,7.65-7.65,7.65c-4.23,0-7.65-3.43-7.65-7.65c0-4.23,3.43-7.65,7.65-7.65S-675.91,354.39-675.91,358.62 C-675.91,358.62-675.91,358.62-675.91,358.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11261_00000152253139221713020930000006450591197881698991_",
    className: "st6",
    d: "M-675.91,700.45 c0,4.23-3.42,7.65-7.65,7.65c-4.23,0-7.65-3.42-7.65-7.65c0-4.23,3.42-7.65,7.65-7.65c0,0,0,0,0,0 C-679.34,692.8-675.91,696.23-675.91,700.45z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11165_00000101794369177664343930000003756752917130232719_",
    transform: "translate(0 60.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11262_00000088120787249847790800000011989296788703033990_",
    className: "st6",
    d: "M-452.58,477.12 c-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65c4.23,0,7.65,3.43,7.65,7.65C-444.93,473.69-448.36,477.12-452.58,477.12 L-452.58,477.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11263_00000034052252632553061510000018098048962071427719_",
    className: "st6",
    d: "M-794.42,477.12 c-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65c4.23,0,7.65,3.43,7.65,7.65l0,0 C-786.76,473.69-790.19,477.12-794.42,477.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11169_00000141418799463558620110000010054610800907349651_",
    transform: "translate(30.575 7.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11167_00000114054196699612918880000008468148677439884459_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11264_00000105412305206441259780000013739006741067760061_",
    className: "st6",
    d: "M-735.71,382.81 c-0.82,0-1.57-0.43-1.98-1.14l-7.65-13.25c-0.63-1.09-0.25-2.48,0.84-3.11c1.09-0.63,2.48-0.25,3.11,0.84l7.66,13.25 c0.63,1.09,0.26,2.48-0.83,3.11C-734.91,382.7-735.3,382.81-735.71,382.81L-735.71,382.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11168_00000123429047409558817300000005715086199793535895_",
    transform: "translate(60.065 104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11265_00000034786802297351030120000005052004511008548531_",
    className: "st6",
    d: "M-624.86,574.82 c-0.81,0-1.57-0.43-1.97-1.14l-7.65-13.25c-0.63-1.09-0.25-2.48,0.84-3.11c1.09-0.63,2.48-0.25,3.11,0.84l7.65,13.25 c0.63,1.09,0.26,2.48-0.83,3.11c0,0,0,0,0,0C-624.06,574.71-624.46,574.82-624.86,574.82z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11172_00000075876466523272357210000012761889861287583411_",
    transform: "translate(7.606 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11170_00000036247634586365368690000013894293834063670448_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11266_00000060030605847558652500000016120446509277172111_",
    className: "st6",
    d: "M-772.5,419.61 c-0.4,0-0.79-0.1-1.14-0.3l-13.25-7.65c-1.09-0.63-1.46-2.02-0.84-3.11c0.63-1.09,2.02-1.46,3.11-0.84l0,0l13.25,7.65 c1.09,0.63,1.47,2.02,0.84,3.11C-770.93,419.17-771.68,419.61-772.5,419.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11171_00000014613955429610849050000012577095298482996649_",
    transform: "translate(104.035 60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11267_00000016770305007762036440000008166392402900919435_",
    className: "st6",
    d: "M-580.5,530.45 c-0.4,0-0.79-0.1-1.14-0.3l-13.25-7.65c-1.09-0.63-1.46-2.02-0.84-3.11c0.63-1.09,2.02-1.46,3.11-0.84l13.25,7.65 c1.09,0.63,1.47,2.02,0.84,3.11C-578.92,530.02-579.68,530.46-580.5,530.45L-580.5,530.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11175_00000106145351568448415050000007658163379146398595_",
    transform: "translate(7.606 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11173_00000117667995322411727080000013265194597243975051_",
    transform: "translate(104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11268_00000121990516644777011330000018385063068993789086_",
    className: "st6",
    d: "M-593.75,419.61 c-1.26,0-2.28-1.01-2.28-2.27c0-0.82,0.43-1.57,1.14-1.98l13.25-7.65c1.09-0.63,2.48-0.25,3.11,0.84 c0.63,1.09,0.25,2.48-0.84,3.11l-13.25,7.65C-592.96,419.5-593.35,419.61-593.75,419.61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11174_00000152970765777857192520000010972892635550466998_",
    transform: "translate(0 60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11269_00000054247264582466825320000006919535748225686954_",
    className: "st6",
    d: "M-785.75,530.45 c-1.26,0-2.28-1.01-2.28-2.27c0-0.82,0.43-1.57,1.14-1.98l13.25-7.65c1.09-0.63,2.48-0.25,3.11,0.84 c0.63,1.09,0.25,2.48-0.84,3.11l0,0l-13.25,7.65C-784.96,530.35-785.35,530.45-785.75,530.45z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11178_00000155869315064509790050000012996120956732612519_",
    transform: "translate(30.575 7.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11176_00000134226199878451386120000012440072717678056857_",
    transform: "translate(60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11270_00000007430702531546742480000002623679132602556290_",
    className: "st6",
    d: "M-632.51,382.81 c-1.26,0-2.28-1.02-2.27-2.28c0-0.4,0.11-0.79,0.3-1.14l7.65-13.25c0.63-1.09,2.02-1.46,3.11-0.84 c1.09,0.63,1.46,2.02,0.84,3.11l-7.65,13.25C-630.94,382.38-631.7,382.81-632.51,382.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11177_00000096737616701333345790000000847239307393923977_",
    transform: "translate(0 104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11271_00000049906950147437196490000000514427292106462384_",
    className: "st6",
    d: "M-743.36,574.82 c-0.4,0-0.79-0.1-1.14-0.3c-1.09-0.63-1.46-2.02-0.84-3.11c0,0,0,0,0,0l7.65-13.25c0.63-1.09,2.02-1.46,3.11-0.84 c1.09,0.63,1.46,2.02,0.84,3.11l-7.65,13.25C-741.8,574.38-742.55,574.82-743.36,574.82z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11272_00000000206277771745926760000016685377236827318144_",
    className: "st7",
    d: "M-573.12,558.91c0,11.6-9.4,21-21,21 c-11.6,0-21-9.4-21-21s9.4-21,21-21l0,0C-582.52,537.91-573.12,547.31-573.12,558.91z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11182_00000094601943382537433450000001666961987424469438_",
    transform: "translate(71.259 58.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11181_00000018926220631778399440000005029694057282671528_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11273_00000116226293812638629220000000272142575443886761_",
    className: "st1",
    d: "M-676.73,506.1l-48.04-101.08 l68.73,88.33c3.94,5.49,2.69,13.13-2.79,17.08c-5.19,3.73-12.39,2.84-16.5-2.06C-675.88,507.66-676.35,506.9-676.73,506.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11274_00000076593196894291506740000008045069129944244126_",
    className: "st1",
    d: "M-664.08,488.69l162.34,13.03 l-163.09,11.27c-6.73,0.33-12.45-4.87-12.78-11.6c-0.32-6.64,4.73-12.31,11.36-12.77 C-665.53,488.59-664.81,488.61-664.08,488.69z"
  })))))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2545",
    x: 488.99,
    y: 310.95,
    className: "st0",
    width: 102.07,
    height: 62.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_2546_00000012471496948205809980000010215561260775234720_",
    gradientUnits: "userSpaceOnUse",
    x1: -1105.7179,
    y1: 1072.7766,
    x2: -1105.7179,
    y2: 1069.931,
    gradientTransform: "matrix(50.023 0 0 -26.432 55851.3477 28617.6309)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#11CDEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1171EF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2546",
    style: {
      fill: "url(#Rectangle_2546_00000012471496948205809980000010215561260775234720_)"
    },
    d: "M480.36,262 h119.33c6.35,0,11.5,5.15,11.5,11.5v52.2c0,6.35-5.15,11.5-11.5,11.5H480.36c-6.35,0-11.5-5.15-11.5-11.5v-52.2 C468.85,267.15,474,262,480.36,262z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11161",
    transform: "translate(73.586)",
    className: "st2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    className: "st3",
    x1: 413.67,
    y1: 262,
    x2: 413.67,
    y2: 337.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    className: "st3",
    x1: 434.78,
    y1: 262,
    x2: 434.78,
    y2: 337.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    className: "st3",
    x1: 455.89,
    y1: 262,
    x2: 455.89,
    y2: 337.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    className: "st3",
    x1: 476.99,
    y1: 262,
    x2: 476.99,
    y2: 337.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    className: "st3",
    x1: 498.1,
    y1: 262,
    x2: 498.1,
    y2: 337.21
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    className: "st3",
    x1: 519.2,
    y1: 262,
    x2: 519.2,
    y2: 337.21
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11163",
    transform: "translate(21.278 36.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11162",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2547",
    className: "st0",
    d: "M625.8,363.35l30.23-30.23c1.72-1.72,4.5-1.72,6.22,0l54.98,54.98 c1.72,1.72,1.72,4.5,0,6.22L687,424.55c-1.72,1.72-4.5,1.72-6.22,0l-54.98-54.98C624.09,367.85,624.09,365.06,625.8,363.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2548",
    className: "st0",
    d: "M320.24,388.1l54.98-54.98c1.72-1.72,4.5-1.72,6.22,0l30.23,30.23 c1.72,1.72,1.72,4.5,0,6.22l-54.98,54.98c-1.72,1.72-4.5,1.72-6.22,0l-30.23-30.23C318.53,392.6,318.53,389.82,320.24,388.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11183",
    transform: "translate(0 20.812)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_11275_00000078746384642584582420000002750722945160549004_",
    gradientUnits: "userSpaceOnUse",
    x1: -1124.6813,
    y1: 1054.0211,
    x2: -1124.6813,
    y2: 1051.1755,
    gradientTransform: "matrix(157.6601 -26.5983 -26.5983 -157.6601 205854.6719 136600.7188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#384D58"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    style: {
      fill: "url(#Path_11275_00000078746384642584582420000002750722945160549004_)"
    },
    d: "M502.18,338.25 c123.89-20.9,241.26,62.59,262.16,186.47s-62.59,241.26-186.47,262.16S336.61,724.3,315.71,600.41 C294.81,476.53,378.29,359.15,502.18,338.25C502.18,338.25,502.18,338.25,502.18,338.25z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3342",
    className: "st4",
    cx: 540.02,
    cy: 562.57,
    r: 199.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3343",
    className: "st5",
    cx: 540.02,
    cy: 562.57,
    r: 190.2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11180",
    transform: "translate(29.375 29.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11164",
    transform: "translate(60.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11260",
    className: "st6",
    d: "M458.23,362.28c0,4.23-3.43,7.65-7.65,7.65c-4.23,0-7.65-3.43-7.65-7.65 c0-4.23,3.43-7.65,7.65-7.65S458.23,358.05,458.23,362.28C458.23,362.28,458.23,362.28,458.23,362.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11261",
    className: "st6",
    d: "M458.23,704.11c0,4.23-3.42,7.65-7.65,7.65c-4.23,0-7.65-3.42-7.65-7.65 c0-4.23,3.42-7.65,7.65-7.65c0,0,0,0,0,0C454.81,696.46,458.23,699.89,458.23,704.11z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11165",
    transform: "translate(0 60.064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11262",
    className: "st6",
    d: "M681.56,480.78c-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65 c4.23,0,7.65,3.43,7.65,7.65C689.22,477.35,685.79,480.78,681.56,480.78L681.56,480.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    className: "st6",
    d: "M339.73,480.78c-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65 c4.23,0,7.65,3.43,7.65,7.65l0,0C347.38,477.35,343.96,480.78,339.73,480.78z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11169",
    transform: "translate(30.575 7.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    className: "st6",
    d: "M398.44,386.47c-0.82,0-1.57-0.43-1.98-1.14l-7.65-13.25c-0.63-1.09-0.25-2.48,0.84-3.11 c1.09-0.63,2.48-0.25,3.11,0.84l7.66,13.25c0.63,1.09,0.26,2.48-0.83,3.11C399.24,386.36,398.85,386.47,398.44,386.47 L398.44,386.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11168",
    transform: "translate(60.065 104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11265",
    className: "st6",
    d: "M509.29,578.47c-0.81,0-1.57-0.43-1.97-1.14l-7.65-13.25c-0.63-1.09-0.25-2.48,0.84-3.11 c1.09-0.63,2.48-0.25,3.11,0.84l7.65,13.25c0.63,1.09,0.26,2.48-0.83,3.11c0,0,0,0,0,0 C510.08,578.37,509.69,578.48,509.29,578.47z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11172",
    transform: "translate(7.606 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11266",
    className: "st6",
    d: "M361.65,423.27c-0.4,0-0.79-0.1-1.14-0.3l-13.25-7.65c-1.09-0.63-1.46-2.02-0.84-3.11 c0.63-1.09,2.02-1.46,3.11-0.84l0,0l13.25,7.65c1.09,0.63,1.47,2.02,0.84,3.11C363.22,422.83,362.46,423.27,361.65,423.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11171",
    transform: "translate(104.035 60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11267",
    className: "st6",
    d: "M553.65,534.11c-0.4,0-0.79-0.1-1.14-0.3l-13.25-7.65c-1.09-0.63-1.46-2.02-0.84-3.11 c0.63-1.09,2.02-1.46,3.11-0.84l13.25,7.65c1.09,0.63,1.47,2.02,0.84,3.11C555.22,533.68,554.47,534.12,553.65,534.11 L553.65,534.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11175",
    transform: "translate(7.606 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11173",
    transform: "translate(104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11268",
    className: "st6",
    d: "M540.4,423.27c-1.26,0-2.28-1.01-2.28-2.27c0-0.82,0.43-1.57,1.14-1.98l13.25-7.65 c1.09-0.63,2.48-0.25,3.11,0.84c0.63,1.09,0.25,2.48-0.84,3.11l-13.25,7.65C541.19,423.16,540.8,423.27,540.4,423.27z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11174",
    transform: "translate(0 60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11269",
    className: "st6",
    d: "M348.4,534.11c-1.26,0-2.28-1.01-2.28-2.27c0-0.82,0.43-1.57,1.14-1.98l13.25-7.65 c1.09-0.63,2.48-0.25,3.11,0.84c0.63,1.09,0.25,2.48-0.84,3.11l0,0l-13.25,7.65C349.19,534.01,348.8,534.11,348.4,534.11z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11178",
    transform: "translate(30.575 7.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11176",
    transform: "translate(60.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11270",
    className: "st6",
    d: "M501.64,386.47c-1.26,0-2.28-1.02-2.27-2.28c0-0.4,0.11-0.79,0.3-1.14l7.65-13.25 c0.63-1.09,2.02-1.46,3.11-0.84c1.09,0.63,1.46,2.02,0.84,3.11l-7.65,13.25C503.2,386.04,502.45,386.47,501.64,386.47z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11177",
    transform: "translate(0 104.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11271",
    className: "st6",
    d: "M390.79,578.47c-0.4,0-0.79-0.1-1.14-0.3c-1.09-0.63-1.46-2.02-0.84-3.11c0,0,0,0,0,0 l7.65-13.25c0.63-1.09,2.02-1.46,3.11-0.84c1.09,0.63,1.46,2.02,0.84,3.11l-7.65,13.25 C392.35,578.04,391.6,578.47,390.79,578.47z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    className: "st7",
    d: "M561.03,562.57c0,11.6-9.4,21-21,21c-11.6,0-21-9.4-21-21s9.4-21,21-21l0,0 C551.62,541.57,561.03,550.97,561.03,562.57z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11182",
    transform: "translate(71.259 58.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    className: "st1",
    d: "M457.41,509.76l-48.04-101.08L478.1,497c3.94,5.49,2.69,13.13-2.79,17.08 c-5.19,3.73-12.39,2.84-16.5-2.06C458.26,511.32,457.8,510.56,457.41,509.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    className: "st1",
    d: "M470.06,492.35l162.34,13.03l-163.09,11.27c-6.73,0.33-12.45-4.87-12.78-11.6 c-0.32-6.64,4.73-12.31,11.36-12.77C468.61,492.24,469.34,492.27,470.06,492.35z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockin);
export default __webpack_public_path__ + "static/media/Clock in.05a0225d36f6120d30b3868587970182.svg";
export { ForwardRef as ReactComponent };